export default "__VITE_ASSET__2877d34b__"